import  { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

const AboutDescriptionSection = ({content, active }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(active || "who");
  
  const tabs = [
    { id: "who", label: content.tab1Heading, content: content.tab1Content },
    { id: "what", label: content.tab2Heading, content: content.tab2Content },
    { id: "why", label: content.tab3Heading, content: content.tab3Content },
  ];

  // Update activeTab when URL parameter changes
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const urlActive = query.get("active");
    
    if (urlActive && tabs.some(tab => tab.id === urlActive)) {
      setActiveTab(urlActive);
    }
  }, [location.search]);

  // Update URL when activeTab changes internally
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    query.set("active", activeTab);
     query.set("scroll", "0");
    navigate(`${location.pathname}?${query.toString()}`, { replace: true });
  }, [activeTab, location.pathname, navigate]);

  return (
    <div className="2xl:max-w-[48%] lg:max-w-[60%] max-w-[90%] mx-auto min-h-[100px] mt-8 sm:mt-10">
      {/* Desktop / Tablet */}
      <div className="hidden sm:block">
        <div className="flex flex-row items-center gap-2 sm:gap-10 2.5xl:gap-0 justify-between">
          {tabs.map((tab,index) => (
            <button
              key={index}
              title="Click to view more details"
              onClick={() => setActiveTab(tab.id)}
              className={`2.5xl:w-[252px] w-[30%] h-[35px] 2.5xl:h-[53px] flex items-center justify-center gap-1 px-2 hover:border-[5px] rounded-md text-base font-mono transition whitespace-nowrap border border-green
                ${activeTab === tab.id ? "bg-green text-white" : "bg-transparent text-green"}
              `}
            >
              <span className="text-[18px] 2.5xl:text-[30px] text-center">{tab.label}</span>
            </button>
          ))}
        </div>
        <div className="mt-10 2.5xl:mt-16 text-left min-h-[80px] flex justify-center items-center 2.5xl:px-2">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="text-base font-mono abouthtml"
              dangerouslySetInnerHTML={{
                __html: tabs.find((t) => t.id === activeTab).content,
              }}
            />
          </AnimatePresence>
        </div>
      </div>
      {/* Mobile */}
      <div className="block sm:hidden mt-6 space-y-6">
        {tabs.map((tab,index) => (
          <div key={index} className="text-left">
            <button
              onClick={() => setActiveTab(tab.id)}
              className="w-full h-[53px] flex items-center justify-center gap-1 px-2 rounded-[10px] text-base font-mono transition whitespace-nowrap border border-green bg-green text-white"
            >
              <span className="text-[32px] text-center">{tab.label}</span>
            </button>
            <div
              className="text-24pt leading-tight font-mono mt-6 "
              dangerouslySetInnerHTML={{ __html: tab.content }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
export default AboutDescriptionSection;
